import { format, getDay } from 'date-fns'
import { NumberFormatter } from './number-formatter'
import { Variant } from '@/types'
import { useI18n } from 'vue-i18n'

export const formatPrice = (value: number) => NumberFormatter.price(value)

export const formatTime = (value: number) => NumberFormatter.time(value)

const getWeekday = (datetime: number): string => {
  const weekdays = ['日', '月', '火', '水', '木', '金', '土']
  return weekdays[getDay(datetime)]
}

export function formatDate (value: string) {
  const datetime = Date.parse(value)
  const weekday = getWeekday(datetime)

  return format(datetime, `yyyy年M月d日(${weekday})`)
}

export function formatDatetime (value: string) {
  const datetime = Date.parse(value)
  const weekday = getWeekday(datetime)

  return format(datetime, `yyyy年M月d日(${weekday}) HH:mm`)
}

export type ItemColorFormatter = (variant: Variant) => string

export const useItemColorFormatter = (): ItemColorFormatter => {
  return (variant: Variant) => useI18n().t(`item-color.${variant.itemColor.name}`)
}
